// PEOPLE SEARCH
// ===================================================

var people_search = {

    settings: {
        advisor_search: $('#advisor-search'),
        advisor_tab: $('#js-advisor-filter-tab'),
    },

    init: function() {
        // Advisor Search
        if (this.settings.advisor_search.length) {
            this.advisorSearch();
        }
    },

    // Advisor Search Functionality
    advisorSearch: function() {

        // Submit form on select change
        $('#advisor_location, #advisor_type').on('change', function() {
            people_search.settings.advisor_search.submit();
        });

        // Remove filter on click
        people_search.settings.advisor_search.find('.js-people-filter-reset').on('click', function() {
            // Filter input to check
            var input = $(this).closest('.search-filter-tab').find('.js-people-filter');
            // Type: input
            if (input[0].nodeName == 'INPUT') {
                input.val('');
                people_search.settings.advisor_search.submit();
            }
            // Type: select
            if (input[0].nodeName == 'SELECT') {
                input.prop('selectedIndex', 0);
                people_search.settings.advisor_search.submit();
            }
        });

        // Mobile tabs dropdown
        var mobile_tabs = $('.intro-people-search').find('.tabs-dropdown select');
        // Update hidden input with current tab
        mobile_tabs.on('change', function() {
            people_search.settings.advisor_tab.val($(this).find(':selected').index().toString());
        });
        // On page load set active tab based on hidden input value
        mobile_tabs.prop('selectedIndex', people_search.settings.advisor_tab.val()).change();

        // Desktop tabs
        var desktop_tabs = $('.intro-people-search').find('.component-tab-bar--tabs .component-tab-bar--tab');
        // Update hidden input with current tab
        desktop_tabs.on('click', function() {
            people_search.settings.advisor_tab.val($(this).index().toString());
        });
        // On page load set active tab based on hidden input value
        desktop_tabs.eq(people_search.settings.advisor_tab.val()).click();

    },

};
people_search.init();